export const APP_NAME = "Twizz";
export const I18NEXT_LANGUAGE_KEY = "i18nextLng";
// SUBSCRIPTION_PRICING_LIMITS contains the maximum subscription prices
// for different subscription periods.

export const SHIFT4_AS_DEFAULT_PAYMENT_GATEWAY = "shift4";
export const SUBSCRIPTION_PRICING_LIMITS = {
  MINIMUM: 5, // Minimum price for subscription
  MONTHLY: 300, // Maximum price for a monthly subscription
  TRIMESTRIAL: 500, // Maximum price for a trimestrial subscription
};

export const PAYMENT_ERROR_MESSAGES = [
  "incorrect_cvc",
  "insufficient_funds",
  "card_declined",
  "card_blocked",
  "authentication_required",
  "promotion_code-already_used",
];

export const PUBLIC_LIVES_LINK = `${window.location.origin}/p/fan/lives`;
